"use client";

import CheckIfTrial from "@/components/CheckIfTrial";
import ClientSide from "@/components/ClientSide";
import { UserContext } from "@/components/Page";
import RecipesPage from "@/components/RecipesPage";

export default function Recipes() {
  return (
    <CheckIfTrial>
      <UserContext.Consumer>
        {(user) => (
          <ClientSide>
            <RecipesPage user={user} />
          </ClientSide>
        )}
      </UserContext.Consumer>
    </CheckIfTrial>
  );
}
